import { connect } from 'react-redux';
import lastProductStateLegacy from '../../../../components/features/lastProductState/LastProductStateLegacy';

import { getProductsStatesLegacy } from 'core/slices/productsStates';
import { getStoreCategories } from 'core/slices/store';
import { getUserStores, getUserSuppliers } from 'core/slices/users';

import {
    categories,
    getSelectedClient,
    getUserStoresAllList,
    isLoadingCategories,
    isLoadingProductsStatesLegacy,
    isLoadingUserStores,
    isLoadingUserSuppliers,
    productsStatesLegacy,
    userChains,
    userSuppliers
} from 'core/selectors';

export default connect(state => ({
    isLoadingUserStores: isLoadingUserStores(state),
    selectedClient: getSelectedClient(state),
    userChains: userChains(state),
    userStores: getUserStoresAllList(state),
    categories: categories(state),
    isLoadingCategories: isLoadingCategories(state),
    suppliers: userSuppliers(state),
    isLoadingSuppliers: isLoadingUserSuppliers(state),
    isLoadingProductsStatesLegacy: isLoadingProductsStatesLegacy(state),
    productsStatesLegacy: productsStatesLegacy(state),
}), {
    getUserStores,
    getStoreCategories,
    getUserSuppliers,
    getProductsStatesLegacy
})(lastProductStateLegacy);
